import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/** Where a demo session always begins, and always returns to. */
export const DEMO_HOME = '/flow-builder?new=1&mode=assistant';

/**
 * A demo account has one screen: the builder.
 *
 * Everything else the app can show, the flows list, settings, submissions, bookings, is either
 * refused outright for a demo session (`DemoRestrictionFilter`) or reduced to a notice saying it
 * comes with an account. Routing a stranger to a page whose entire content explains why it is
 * empty is a worse first impression than not having the page, and every one of those screens was
 * another chance to wander off the one thing the demo is for.
 *
 * Expressed as ROUTES rather than as hidden nav links, because hiding a link is not closing a
 * door. A bookmark, a pasted URL or a guess all land back on the builder.
 *
 * Signing up ends it on the next render: `isDemoMode` comes from the auth context, and the
 * session that replaces the demo one is not a demo session.
 *
 * @param builder   the element for /flow-builder, the only page a demo account may open
 * @param children  the full route table, for everybody else
 */
const DemoRoutes = ({ builder, children }) => {
  const { isDemoMode } = useAuth();
  if (!isDemoMode) {
    return children;
  }
  return (
    <Routes>
      <Route path="/flow-builder" element={builder} />
      <Route path="/flow-builder/:flowId" element={builder} />
      <Route path="*" element={<Navigate to={DEMO_HOME} replace />} />
    </Routes>
  );
};

export default DemoRoutes;
